import setValue from '../../shared/actions/setValue'

const updateItem = (id, key, value, dispatch, { main }, list) => {
  const results = main[list]
  const newResults = results.map((item) => {
    if (item.id === id) {
      return { ...item, [key]: value }
    }
    return item
  })
  dispatch(setValue(list, newResults))
}

/**
 *  Update item in a list of store
 *
 * @param id
 * @param key
 * @param value
 * @param list
 * @returns {function(*=, *): Promise<void>}
 */
export default (id, key, value, list = 'results') => (dispatch, getState) => updateItem(id, key, value, dispatch, getState(), list)
